import { render, staticRenderFns } from "./sugerencias.vue?vue&type=template&id=67495f59&scoped=true&"
import script from "./sugerencias.vue?vue&type=script&lang=js&"
export * from "./sugerencias.vue?vue&type=script&lang=js&"
import style0 from "./sugerencias.vue?vue&type=style&index=0&id=67495f59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67495f59",
  null
  
)

export default component.exports